import { render, staticRenderFns } from "./UsuarioEditar.vue?vue&type=template&id=42407f48&scoped=true&"
import script from "./UsuarioEditar.vue?vue&type=script&lang=js&"
export * from "./UsuarioEditar.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioEditar.vue?vue&type=style&index=0&id=42407f48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42407f48",
  null
  
)

export default component.exports